/**
 * Authentication state management utilities
 * Uses Vue's reactive system to ensure UI updates on auth changes
 */
import { ref } from 'vue'

export interface AuthState {
    isAuthenticated: boolean
    username: string | null
    token: string | null
}

const TOKEN_KEY = 'auth_token'
const USERNAME_KEY = 'auth_username'

// Reactive state
const token = ref<string | null>(localStorage.getItem(TOKEN_KEY))
const username = ref<string | null>(localStorage.getItem(USERNAME_KEY))

/**
 * Get the JWT token
 */
export function getToken(): string | null {
    return token.value
}

/**
 * Store the JWT token
 */
export function setToken(newToken: string): void {
    token.value = newToken
    localStorage.setItem(TOKEN_KEY, newToken)
}

/**
 * Remove the JWT token
 */
export function clearToken(): void {
    token.value = null
    username.value = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USERNAME_KEY)
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated(): boolean {
    return token.value !== null
}

/**
 * Get the stored username
 */
export function getUsername(): string | null {
    return username.value
}

/**
 * Store the username
 */
export function setUsername(newUsername: string): void {
    username.value = newUsername
    localStorage.setItem(USERNAME_KEY, newUsername)
}

/**
 * Get the current auth state
 */
export function getAuthState(): AuthState {
    return {
        isAuthenticated: isAuthenticated(),
        username: getUsername(),
        token: getToken()
    }
}

/**
 * Clear all authentication data
 */
export function logout(): void {
    clearToken()
}


